import React, { FC } from "react";

interface HotelIconProps {
  className?: string;
}

const HotelIcon: FC<HotelIconProps> = ({ className }) => {
  return (
   <svg  xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" width="24" height="24" className={`MuiTab-iconWrapper ${className}`}><path d="M2.25 16V13.75C2.25 12.6454 3.14543 11.75 4.25 11.75H19.75C20.8546 11.75 21.75 12.6454 21.75 13.75V16M2.25 19.5V7.5C2.25 5.84315 3.59315 4.5 5.25 4.5H18.75C20.4069 4.5 21.75 5.84315 21.75 7.5V19.5M21.75 16.25H2.25M4.5 11.75V10.75C4.5 9.64543 5.39543 8.75 6.5 8.75H10C11.1046 8.75 12 9.64543 12 10.75M12 10.75V11.75M12 10.75C12 9.64543 12.8954 8.75 14 8.75H17.5C18.6046 8.75 19.5 9.64543 19.5 10.75V11.75" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>

  );
};

export default HotelIcon;
